import { syntaxFNMA } from '@aloft/toolkit-shared';

export const normalizeRentalListingStatus = (
  status: string | undefined,
): syntaxFNMA.RentalListingStatus | undefined => {
  const normalized = status?.toLowerCase().trim();

  if (!normalized) return undefined;
  if (normalized.includes('contract') || normalized.includes('pending')) return 'Pending';
  if (
    normalized.includes('rent') ||
    normalized.includes('leased') ||
    normalized === 'closed' ||
    normalized.includes('sold')
  ) {
    return 'Rented';
  }
  if (normalized === 'active' || normalized.includes('active')) return 'Active';

  return undefined;
};
